export type UserType = 'internal' | 'external'

export class UserTypeService {
	private static userType: UserType = 'external'
	private static initialized = false

	static async init() {
		if (this.initialized) return

		try {
			const response = await fetch('/api/user-type')
			const data = await response.json()

			if (data.userType && ['internal', 'external'].includes(data.userType)) {
				this.userType = data.userType
				this.initialized = true
				console.log(`Initialized with user type: ${this.userType}`)
			}
		} catch (error) {
			console.warn('Failed to fetch user type, using default:', error)
		}
	}

	static getUserType(): UserType {
		return this.userType
	}

	static isInternal(): boolean {
		return this.userType === 'internal'
	}

	static isExternal(): boolean {
		return this.userType === 'external'
	}
}
